// extracted by mini-css-extract-plugin
module.exports = {"content":"eeb6c9d23e--content--sXiMd","with-shadow":"eeb6c9d23e--with-shadow--BdV6t"};